import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import LoadMoreButton from "../component/LoadMoreButton";
import aboutAPI from "../api/aboutApi";
import {Link} from "react-router-dom";

const VisitorGuest = () => {
  const [visibleCards, setVisibleCards] = useState(8);
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const loadMoreRef = useRef(null);

  const loadMore = () => {
    setVisibleCards((prev) => prev + 8);
  };

  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        const response = await aboutAPI.visitors_guests_api();
        if (response.code === 200) {
          setVisitors(response.data || []);
        } else {
          setVisitors([]);
        }
      } catch (error) {
        console.error("Error fetching visitors:", error);
        setVisitors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitors();
  }, []);

  useEffect(() => {
    if (loading) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && visibleCards < visitors.length) {
          loadMore();
        }
      },
      { threshold: 1 },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [loading, visibleCards, visitors.length]);

  return (
    <div className="visitor-page-root">
      <BreadCrumbBanner
        title="Visitors & Guests"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <section className="mrv-premium-guest-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <span className="mrv-subtitle">DISTINGUISHED VISITS</span>
            <h2 className="mrv-title">Honoured Guests at MRV</h2>
          </div>

          <div className="row g-3">
            {loading ? (
              <div className="text-center py-5">
                <p>Loading...</p>
              </div>
            ) : visitors.length > 0 ? (
              visitors.slice(0, visibleCards).map((guest, index) => (
                <div className="col-lg-3 col-md-6" key={index}>
                  <motion.div
                    className="mrv-elite-card"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                  >
                    <div className="mrv-card-upper">
                      <img
                        src={guest.image}
                        alt={guest.name}
                        className="mrv-guest-img"
                        loading="lazy"
                      />
                      {guest.date && (
                        <div className="mrv-overlay-date">{guest.date}</div>
                      )}
                    </div>

                    <div className="mrv-card-lower">
                   
                        <Link to={`/visitors-and-guests/${guest.id}`} className="text-decoration-none mrv-name">
                          {guest.name}
                        </Link>
                      
                      <p
                        className="mrv-subtitle"
                        style={{ height: "26px", fontSize: "11px" }}
                      >
                        {guest.designation}
                      </p>
                      <div className="mrv-content-wrap">
                        <div className="mrv-reason">
                          <p
                            dangerouslySetInnerHTML={{
                              __html: guest.description,
                            }}
                          />
                        </div>
                      </div>
                      <Link
                        to={`/visitors-and-guests/${guest.id}`}
                        className="mrv-guest-more text-decoration-none"
                      >
                        Read more →
                      </Link>
                    </div>
                  </motion.div>
                </div>
              ))
            ) : (
              <div className="text-center py-5">
                <p>No visitors found.</p>
              </div>
            )}
          </div>

          {!loading && visibleCards < visitors.length && (
            <div ref={loadMoreRef} style={{ height: "1px" }} />
          )}
        </div>
      </section>
    </div>
  );
};

export default VisitorGuest;
